import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBoat: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="boat, ship, sailing"><path d="M12.75 16.5V2.75C12.75 2.75 5.81667 6.375 3.75 13.1071C8.96256 12.4455 14.0421 12.5739 19.25 13.1071C18.1823 9.18329 16.15 6.375 13.5667 4.82143" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M5.75 21.25L2.75 16.75H21.25L18.256 21.25H5.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBoat;
